import { useDraggable } from "@dnd-kit/core";
import { Lead } from "../lib/api";

interface Props {
  lead: Lead;
  productLabel: string;
  sourceLabel: string;
}

export function LeadCardView({ lead, productLabel, sourceLabel }: Props) {
  return (
    <div className="lead-card">
      <h4>{lead.name || `Лид #${lead.lead_id}`}</h4>
      <div className="meta">
        <span>{productLabel}</span>
        <span>·</span>
        <span>{sourceLabel}</span>
      </div>
      {lead.deal_amount != null && (
        <div className="meta" style={{ marginTop: 4 }}>
          <span className="amount">{Number(lead.deal_amount).toLocaleString("ru-RU")} ₽</span>
        </div>
      )}
      {lead.assignee_username && (
        <div className="meta" style={{ marginTop: 4 }}>@{lead.assignee_username}</div>
      )}
    </div>
  );
}

export function LeadCardDraggable(props: Props) {
  const { attributes, listeners, setNodeRef, transform, isDragging } = useDraggable({
    id: props.lead.lead_id,
  });
  const style: React.CSSProperties = {
    opacity: isDragging ? 0.4 : 1,
    transform: transform ? `translate3d(${transform.x}px, ${transform.y}px, 0)` : undefined,
  };
  return (
    <div ref={setNodeRef} style={style} {...listeners} {...attributes}>
      <LeadCardView {...props} />
    </div>
  );
}
